import { render, staticRenderFns } from "./MyAccountSinir.vue?vue&type=template&id=733bda72&scoped=true&"
import script from "./MyAccountSinir.vue?vue&type=script&lang=js&"
export * from "./MyAccountSinir.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountSinir.vue?vue&type=style&index=0&id=733bda72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733bda72",
  null
  
)

export default component.exports